<template>
    <ob1-popin-modal2
        :id="modalId"
        :aria-labelledby="modalLabelId"
        @ob1-popin-modal-click="closePopin"
    >
        <div :id="modalLabelId" class="h4" v-html="messages.title" />
        <recovery-simulator
            ref="simulator"
            :shop="shop"
            :messages="messages"
            :modal-id="modalId"
            @update-recovery-simulation="updateRecoveryPrice"
        />
    </ob1-popin-modal2>
</template>

<script>
import RecoverySimulator from "./recoverysimulator/RecoverySimulator.vue";

export default {
    name: "MobileRecoverySimulatorModal",
    components: {RecoverySimulator},
    props: {
        modalId: {
            type: String,
            required: true,
        },
        shop: {
            type: String,
            required: true,
        },
        messages: {
            type: Object,
            required: true
        },
    },
    computed: {
        modalLabelId: function () {
            return this.modalId + "-label";
        }
    },
    mounted: function () {
        $(`#${this.modalId}`).on("hidden.bs.modal", () => {
            this.closePopin();
        });
    },
    methods: {
        closePopin() {
            this.$refs.simulator.reset();
        },
        updateRecoveryPrice(priceInCents, model) {
            this.$emit('update-recovery-simulation', priceInCents, model);
        }
    }
}
</script>
